export default __webpack_public_path__ + "static/media/presentation-bg-01.da2d5e13.jpeg";